import * as React from "react";
import { connect } from "react-redux";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export interface IState {}

export interface IProps {
  config?: any;
}

export class LogProvider extends React.Component<IProps, IState> {
  componentDidMount() {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: this.props.config.appInsightsKey
      }
    });
    appInsights.loadAppInsights();
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = (state: any) => ({
  config: state.config.config
});

export const Logger = connect(mapStateToProps)(LogProvider);
